<script setup lang="ts"></script>

<template>
  <NuxtLayout></NuxtLayout>
</template>
